import type { AuthorizedPool } from '../data/types';

interface Props {
  pools: AuthorizedPool[];
  selectedLeagueId: number | null;
  onChange: (leagueId: number) => void;
}

export function CiPoolSelector({ pools, selectedLeagueId, onChange }: Props) {
  if (pools.length <= 1) {
    // Un seul pool : afficher le nom en texte statique, pas de sélecteur.
    const pool = pools[0];
    if (!pool) return null;
    return (
      <span className="ci-header__user" data-testid="ci-pool-single">
        Pool : <strong>{pool.league_name}</strong>
      </span>
    );
  }
  return (
    <label className="ci-header__user">
      <span style={{ marginRight: 8 }}>Pool :</span>
      <select
        className="ci-select"
        value={selectedLeagueId ?? ''}
        onChange={(e) => onChange(Number(e.target.value))}
        data-testid="ci-pool-selector"
      >
        {pools.map((p) => (
          <option key={p.league_id} value={p.league_id}>
            {p.league_name}
          </option>
        ))}
      </select>
    </label>
  );
}
